const storeVipDetailReducers = (state = [], action) => {
  switch (action.type) {
    case "storeVipDetail":
      return action.payload;
    default:
      return state;
  }
};
export default storeVipDetailReducers;
